// Function to reorganize color swatches by price groups
function reorganizeColorSwatchesByPrice() {
  var currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  let product = {}

  try {
    product = JSON.parse(document.getElementById('ProductJson').innerHTML);
  } catch {
    return;
  }

  // This function re-runs on every swatch click, so clear out the wrappers the
  // previous run appended before building new ones -- otherwise the price
  // labels stack up. The .swatch__option nodes are the real swatches that get
  // moved into those wrappers, so lift them back out before removing.
  var $swatchOptions = $('.color-swatch .swatch__options');
  var $previousGroups = $swatchOptions.find('.swt-price-group');
  if ($previousGroups.length) {
    $swatchOptions.append($previousGroups.find('.swatch__option'));
    $previousGroups.remove();
  }
  var $colorSwatch = $('.color-swatch');
  var $previousLabel = $colorSwatch.find('.swt-price-group-label');
  if ($previousLabel.length) {
    $colorSwatch.prepend($previousLabel.children());
    $previousLabel.remove();
  }

  let sortingObject = {
    color: "",
    price: "",
    commPrice: ''
  }
  let sortDataArry = [];
  let elemntArray = [];
  product.variants.forEach((variant) => {
    if (variant.available) {
      let sortObj = Object.create(sortingObject);
      sortObj.color = variant.option1;
      sortObj.price = variant.price;
      sortObj.commPrice = variant.compare_at_price;
      sortDataArry.push(sortObj);
    }
  })

  const key = 'color';
  const unique = [...new Map(sortDataArry.map(item =>
    [item[key], item])).values()];

  // Group by price using vanilla JavaScript
  var grouped = unique.reduce((acc, item) => {
    const price = item.price;
    if (!acc[price]) {
      acc[price] = [];
    }
    // Omit the price property from the item
    const { price: _, ...itemWithoutPrice } = item;
    acc[price].push(itemWithoutPrice);
    return acc;
  }, {});
  
  if (Object.keys(grouped).length > 1) {
    var swatches = $('.color-swatch .swatch__options').find(".swatch__option");
    for (let index = 0; index < swatches.length; index++) {
      const element = swatches[index];
      elemntArray.push(element);
    }
    var keys = Object.keys(grouped);
    keys.sort(function (a, b) { return b - a });
    let colorSwath = [];

    const prices = Object.keys(grouped).map(price => parseFloat(price));

    // Find the lowest price
    const lowestPrice = (Math.min(...prices))/100;

    // Retrieve the object(s) corresponding to the lowest price
    const lowestPriceObjects = grouped[lowestPrice];

    
    for (var i = 0; i < keys.length; i++) {
      var val = grouped[keys[i]];
      let comPrice = val[0].commPrice > keys[i] ? val[0].commPrice : " ";
      let outerWrapper = "";
      let mdClass = "md-" + Math.floor(keys[i] / 100);
      let nmClass = "nm-" + Math.floor(keys[i] / 100);
      if (comPrice > 0) {
        if(lowestPrice!=(keys[i] / 100)){
          outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" }).append($("<div>", { "class": mdClass,"style": "line-height: normal;" }).append($("<span>", { "class": "product__price--old pdp_color_group_price" }).append($("<s>", {
            "tabindex": "0"
          }).text(currency.format(comPrice / 100))))).append($("<div>", {"class": mdClass,"style": "line-height: initial;" }).append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100))));
        }else{
          // Clearance price colour is #D32121, the theme's own sale_color
          // setting. Plain `red` (#ff0000) is 4.00:1 on white -- under the
          // 4.5:1 this 14px text needs. #D32121 is 5.24:1 and matches the sale
          // price colour used elsewhere in the store.
          if ((lowestPrice/(comPrice / 100))< 0.51) {
            // The price span is built with its text in one step. The previous
            // version appended an empty <span tabindex="0">, then called
            // .text() on the parent div -- which wipes every child -- so the
            // span was destroyed and the price ended up as a bare text node
            // with no tab stop, before " Clearance" was appended after it.
            outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" })
              .append($("<div>", { "class": mdClass, "style": "line-height: normal;" })
                .append($("<div>", { "class": mdClass + " product__price--sale ", "style": "line-height: initial;font-size:14px;margin-top: 2px; color:#D32121;" })
                  .append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100)))
                  .append($("<span>", { "class": "product__price--sale product__price--old pdp_grp_non_sale pdp_color_group_price ", "tabindex": "0", "style": "color:black;" }).text(" Clearance"))));
          }else{
            outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" }).append($("<div>", { "class": mdClass,"style": "line-height: normal;" }).append($("<span>", { "class": "product__price--old pdp_color_group_price" }).append($("<s>", {
              "tabindex": "0"
            }).text(currency.format(comPrice / 100))))).append($("<div>", {"class": mdClass,"style": "line-height: initial;" }).append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100))));
          }
          
         }
        
      } else {
        outerWrapper = $("<div>", { "class": "non-markdown-swt " + nmClass, "style": "position: relative; margin-right: 25px;" }).append($("<div>", { "class": nmClass }).append($("<span>", { "class": "product__price--old pdp_grp_non_sale pdp_color_group_price ", "tabindex": "0" }).text(currency.format(keys[i] / 100)))).append($("<div>").append($("<span>", { "class": "product__price--old" }).text()));
      }
      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        for (let i = 0; i < elemntArray.length; i++) {
          const pageElement = elemntArray[i];
          const swatchElement = pageElement.querySelector('.swatch-element');
          const inputElement = pageElement.querySelector('input[data-variant-option-value]');
          const colorValue = inputElement ? inputElement.value : '';
          
          if (colorValue == element.color) {
            pageElement.style.display = "inline-block";
            pageElement.style.position = "relative";
            if(outerWrapper!=""){
              outerWrapper.append(pageElement);
            }
            
          }
        }
      }
      colorSwath.push(outerWrapper);
    }

    let saleDiv = $("<div>", { "class": "swt-price-group", "style": "width: fit-content;" });
    let saleNonDiv = $("<div>", { "class": "swt-price-group", "style": "display: block" });
    for (let index = 0; index < colorSwath.length; index++) {
      const element = colorSwath[index];
      if (element.hasClass("non-markdown-swt")) {
        saleDiv.append(element);
      }
    }
    $('.color-swatch .swatch__options').append(saleDiv);
    for (let index = 0; index < colorSwath.length; index++) {
      const element = colorSwath[index];
      if (element.hasClass("markdown-swt")) {
        saleNonDiv.append(element);
      }
    }
    $('.color-swatch .swatch__options').append(saleNonDiv);
    document.querySelector('.color-swatch .swatch__options').classList.add('display-block-pdp-swt');

    $('.color-swatch').css('display', 'block');
    $('.color-swatch').find('.option-title').addClass('pdp-color-group-heading');

    let lableDv = $("<div>", { "class": "swt-price-group-label", "style": "display: inline-flex;" });
    lableDv.append($('.pdp-color-group-heading').addClass('grp-lable-color grp-lable')).append($('.color-swatch .options-selection__option-name').addClass('grp-lable-color'))
    $('.color-swatch').prepend(lableDv);

  }

  var keys = Object.keys(grouped);
  keys.sort((a, b) => b - a);
  let dataValues = "";
   
  for (var i = 0; i < keys.length; i++) {
    var val = grouped[keys[i]];
    let comPrice = val[0].commPrice > keys[i] ? val[0].commPrice : " ";
    let calcValue = Math.floor(keys[i] / 100);

    if (comPrice > 0) {
      let mdClass = "md-" + calcValue;
      dataValues += mdClass + '#';
        let markdownDivs = document.querySelectorAll('.markdown-swt');

        markdownDivs.forEach(div => {
            if (div.classList.contains(mdClass)) {
                let productSwatches = div.querySelectorAll('.swatch__option');

                productSwatches.forEach(swatch => {
                    swatch.classList.add(mdClass);
                });
            }
        });

         // Add the condition for .swatch__option without .markdown-swt or .non-markdown-swt
      let samePriceSwatches = document.querySelectorAll('.swatch__option');
      samePriceSwatches.forEach(swatch => {
        if (!swatch.closest('.markdown-swt') && !swatch.closest('.non-markdown-swt')) {
          swatch.classList.add(mdClass);
          swatch.classList.add('samePrice');
        }
      });
    } else {
      let nmClass = "nm-" + calcValue;
      dataValues += nmClass + '#';
        let nonMarkdownDivs = document.querySelectorAll('.non-markdown-swt');
        nonMarkdownDivs.forEach(div => {
          if (div.classList.contains(nmClass)) {
            let productSwatches = div.querySelectorAll('.swatch__option');

            productSwatches.forEach(swatch => {
                swatch.classList.add(nmClass);
            });
          }
        });

      // Add the condition for .swatch__option without .markdown-swt or .non-markdown-swt
      let samePriceSwatches = document.querySelectorAll('.swatch__option');
      samePriceSwatches.forEach(swatch => {
        if (!swatch.closest('.markdown-swt') && !swatch.closest('.non-markdown-swt')) {
          swatch.classList.add(nmClass);
          swatch.classList.add('samePrice');
        }
      });
    }
  }

  // Get all elements with the class 'samePrice'
  let samePriceElements = document.querySelectorAll('.samePrice');

  dataValues = dataValues.slice(0, -1);

  samePriceElements.forEach(swatch => {
    swatch.setAttribute('data-group', dataValues);
    swatch.classList.add('price-tag');
  });

  document.querySelectorAll('.markdown-swt *, .non-markdown-swt *').forEach(element => {
    element.setAttribute('data-group', dataValues);
    element.classList.add('price-tag');
  });

  var priceList = dataValues.split('#');
 
  var allPriceTagElements = document.querySelectorAll('.price-tag');

  var priceGroupsElements = [];

  priceList.forEach(classInList => {
    let elementsWithClass = Array.from(allPriceTagElements).filter(element => element.classList.contains(classInList));

    if (elementsWithClass.length > 0) {
      priceGroupsElements.push(elementsWithClass);
    }
  });

  let singlePriceAvailable = false;
  const valueLabel = document.querySelector('.color-value-spn');
  const colorLabel = document.querySelector('.color-label');
  const focusableSelector = 'input, span, button, textarea, select, a[href], [tabindex]:not([tabindex="-1"]), [tabindex="0"]';

  priceGroupsElements.forEach((priceGroup) => {
    priceGroup.forEach((element) => {
      // A keydown listener used to be bound here calling handleTabShiftKeyDown,
      // but that function is not defined anywhere in the theme -- so every key
      // press on a price-tag element threw ReferenceError. It only surfaced
      // once the swatches became focusable; before that nothing could put
      // keyboard focus on them to fire it.
      //
      // Removing it costs nothing: the grouping moves the swatches into their
      // price wrappers in the DOM, so the browser's own Tab order already
      // follows the visual grouping.
      if (element._swtTabHandler) {
        element.removeEventListener('keydown', element._swtTabHandler);
        delete element._swtTabHandler;
      }

      if (element.classList.contains('samePrice')) {
       singlePriceAvailable = true;
      }
    });
  });

  function setFocusToElement(element, focusableSelector) {
    let focusTarget = element.querySelector(focusableSelector);

    if (focusTarget) {
      focusTarget = focusTarget.querySelector(focusableSelector) || focusTarget;
    } else {
      focusTarget = element;
    }
    focusTarget.focus();
  }

  let searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('variant')) {
    let param = searchParams.get('variant');
    let currentObject = product.variants.find(item => item.id == param);
    let currentId = "";
    if (currentObject != null) {
      currentId = currentObject.option1
    }
    if (currentId != "") {
      $('.thumbnail-list__item').removeClass('hide-imgs');
      $('.thumbnail-list__item').each(function () {
        let dataValue = $(this).data("varinet-id");
        if (currentId != dataValue) {
          $(this).addClass("hide-imgs");
        }
        if (dataValue.indexOf(".mp4") !== -1) {
          $(this).removeClass("hide-imgs");
        }
        if (dataValue.toLowerCase().indexOf("common") !== -1) {
          $(this).removeClass("hide-imgs");
        }
      })
    }
  }
}

// Call on page load
window.addEventListener('load', (event) => {
  setTimeout(function() {
        reorganizeColorSwatchesByPrice();
      }, 1200);

// Listen to the radio's own change event rather than a click on the label and
// a keydown on the swatch wrapper. change fires however the selection is made
// -- mouse, Enter/Space, or the arrow keys that move through a radio group --
// so the colour name and the price grouping stay in step with the real state.
// The colour is read from data-value on the swatch; it used to come from that
// element's aria-label, which has been removed because a plain <div> maps to
// role=generic and ignores aria-label anyway.
$(document).on('change', '.swatch__option input[data-variant-option-value]', function () {
  // aria-checked lives on the swatch, not the input, so it has to be refreshed
  // for the whole group every time the selection moves.
  const $group = $(this).closest('[role="radiogroup"]');
  $group.find('.swatch-element[role="radio"]').attr('aria-checked', 'false');
  $(this).siblings('.swatch-element[role="radio"]').attr('aria-checked', 'true');

  const $swatch = $(this).siblings('.swatch-element.color');
  if (!$swatch.length) return;

  const color = $swatch.attr('data-value') || this.value;
  if (!color) return;

  // Scoped to this option's own group and to the value span only. Unscoped,
  // this wrote the colour into every option label on the page -- including
  // Size -- and now that the label is "<span>Colour</span>: <span>Navy</span>"
  // it would also overwrite the option's name with its value.
  $group
    .find('.options-selection__option-name span:last-of-type')
    .text(color);

  // Reorganize swatches by price groups
  setTimeout(function() {
    reorganizeColorSwatchesByPrice();
  }, 150);
});

// The swatch is the control now, so it has to be operable. A mouse click still
// reaches the native input through the <label for>, but a keyboard press on the
// swatch does not -- role="radio" means Enter and Space must both select it.
$(document).on('keydown', '.swatch-element[role="radio"]', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

  event.preventDefault();

  const input = $(this).siblings('input[data-variant-option-value]')[0];
  if (!input || input.checked) return;

  input.checked = true;
  // Dispatched rather than set silently: the theme's variant JS and the
  // change handler above both listen for this.
  $(input).trigger('change');
});

// The Samita product-label markup ("WARMEST", "SALE") is injected by the app,
// so it is not in the theme's templates and cannot be given a tabindex there.
// It also arrives after load and is re-injected on variant change and when the
// gallery re-renders, which is why this watches for new labels rather than
// running once.
const SAMITA_LABEL_TEXT = '.samita_productLabel-content-text > div';

function makeSamitaLabelsFocusable(root) {
  const scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll(SAMITA_LABEL_TEXT).forEach(function (el) {
    // Skip anything already focusable, and empty wrappers -- a tab stop that
    // announces nothing is worse than no tab stop.
    if (el.hasAttribute('tabindex')) return;
    if (!el.textContent.trim()) return;

    el.setAttribute('tabindex', '0');
  });
}

makeSamitaLabelsFocusable();

if (window.MutationObserver) {
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches(SAMITA_LABEL_TEXT)) {
          makeSamitaLabelsFocusable(node.parentNode);
        } else {
          makeSamitaLabelsFocusable(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
});
